import { callMethodOnKeydown } from '../helpers'
import { Renderer } from '../renderer'
import { state } from './state'

class Viewport {
  constructor () {
    this.element = document.getElementById('mct-viewport')
    this.spacer = document.getElementById('mct-spacer')
    this.canvas = document.getElementById('mct-canvas')
    this.container = document.getElementById('mct-sensor-canvas-container')
    this.xCoordElement = document.getElementById('mct-x-coord')
    this.yCoordElement = document.getElementById('mct-y-coord')
    this.mct = document.getElementById('mct-container')
    this.sensorsTab = document.getElementById('mct-sensors-tab')
    this.groupsTab = document.getElementById('mct-groups-tab')
    this.statusBar = document.getElementById('mct-status-bar')
    this.keyMpappingsContainer = document.getElementById('mct-key-mappings')
    this.windowHeight = window.innerHeight
    this.ctx = this.canvas.getContext('2d')

    this.updateCursorPosition = this.updateCursorPosition.bind(this)
    this.resizeCanvas = this.resizeCanvas.bind(this)

    this.resizeObserver = new ResizeObserver(() => {
      this.resizeCanvas()
    })

    this.setContainerSize(false)
    this.setCanvasSize()
    this.scrollToCenter()
    this.bindEvents()
  }

  setCanvasSize () {
    const dpr = window.devicePixelRatio || 1
    const width = this.element.clientWidth
    const height = this.element.clientHeight

    this.canvas.width = Math.floor(width * dpr)
    this.canvas.height = Math.floor(height * dpr)

    this.canvas.style.width = width + 'px'
    this.canvas.style.height = height + 'px'

    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0)
  }

  setContainerSize (fullscreen) {
    const statusBarRect = this.statusBar.getBoundingClientRect()
    const mctRect = this.mct.getBoundingClientRect()
    const viewportRect = this.element.getBoundingClientRect()
    let height
    if (fullscreen) {
      height = statusBarRect.height + (viewportRect.top - mctRect.top)
      this.container.style.height = (screen.height - height) + 'px'
    } else {
      height = statusBarRect.height + viewportRect.top
      this.container.style.height = (this.windowHeight - height) + 'px'
    }
    this.scrollToCenter()
  }

  resizeCanvas () {
    this.setCanvasSize()
    Renderer.render()
  }

  getCamCoordinates () {
    return [this.element.scrollLeft, this.element.scrollTop]
  }

  getCanvasDimensions () {
    return [this.element.clientWidth, this.element.clientHeight]
  }

  getCanvasBackingDimensions () {
    return [this.canvas.width, this.canvas.height]
  }

  getCanvasPosition () {
    const rect = this.canvas.getBoundingClientRect()
    return [rect.left, rect.top]
  }

  scrollToCenter () {
    let centerX
    let centerY

    if (state.mapImage) {
      centerX = state.mapWorld.x + state.mapImage.naturalWidth / 2
      centerY = state.mapWorld.y + state.mapImage.naturalHeight / 2
    } else {
      centerX = this.spacer.offsetWidth / 2
      centerY = this.spacer.offsetHeight / 2
    }

    const halfWorldW = (this.element.clientWidth / 2) / state.zoomValue
    const halfWorldH = (this.element.clientHeight / 2) / state.zoomValue

    let targetLeft = centerX - halfWorldW
    let targetTop = centerY - halfWorldH

    const maxLeft = Math.max(0, this.element.scrollWidth - this.element.clientWidth)
    const maxTop = Math.max(0, this.element.scrollHeight - this.element.clientHeight)

    targetLeft = Math.max(0, Math.min(targetLeft, maxLeft))
    targetTop = Math.max(0, Math.min(targetTop, maxTop))

    this.element.scrollLeft = targetLeft
    this.element.scrollTop = targetTop
  }

  updateCursorPosition (event) {
    const [canvX, canvY] = this.getCanvasPosition()
    const [camX, camY] = this.getCamCoordinates()

    state.cursorWorld = {
      x: Math.round(camX + (event.clientX - canvX) / state.zoomValue),
      y: Math.round(camY + (event.clientY - canvY) / state.zoomValue)
    }

    const originX = this.spacer.offsetWidth / 2
    const originY = this.spacer.offsetHeight / 2

    this.xCoordElement.textContent = state.cursorWorld.x - originX
    this.yCoordElement.textContent = state.cursorWorld.y - originY
  }

  updateBlankCursorPosition () {
    this.xCoordElement.textContent = '--'
    this.yCoordElement.textContent = '--'
  }

  onKeyDown (event) {
    if (event.key === 'F1') {
      callMethodOnKeydown(event.target, () => {
        this.mct.classList.add('show-shortcut')
        setTimeout(() => {
          this.mct.classList.remove('show-shortcut')
        }, 3000)
      })
    }
  }

  bindEvents () {
    this.updateBlankCursorPosition = this.updateBlankCursorPosition.bind(this)
    this.onKeyDown = this.onKeyDown.bind(this)

    this.element.addEventListener('scroll', Renderer.render)
    this.element.addEventListener('mousemove', this.updateCursorPosition)
    this.element.addEventListener('mouseleave', this.updateBlankCursorPosition)
    document.addEventListener('keydown', this.onKeyDown)
    this.resizeObserver.observe(this.element)
  }

  unBindEvents () {
    this.element.removeEventListener('scroll', Renderer.render)
    this.element.removeEventListener('mousemove', this.updateCursorPosition)
    this.element.removeEventListener('mouseleave', this.updateBlankCursorPosition)
    document.removeEventListener('keydown', this.onKeyDown)
    this.resizeObserver.disconnect()
  }
}

export let viewport = null

export function initViewport () {
  viewport = new Viewport()
  return viewport
}
